var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41484 0.467187C8.78009 0.467187 8.26553 0.981754 8.26553 1.6165V17.5875C8.26553 18.2222 8.78009 18.7368 9.41484 18.7368C10.0496 18.7368 10.5642 18.2222 10.5642 17.5875V1.6165C10.5642 0.981754 10.0496 0.467187 9.41484 0.467187Z",
    fill: "#3B3B3B",
    stroke: "#3B3B3B",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41921 8.45352C0.785014 8.45352 0.270898 8.96763 0.270898 9.60183C0.270898 10.236 0.785012 10.7501 1.41921 10.7501H17.4103C18.0445 10.7501 18.5586 10.236 18.5586 9.60183C18.5586 8.96763 18.0445 8.45352 17.4103 8.45352H1.41921Z",
    fill: "#3B3B3B",
    stroke: "#3B3B3B",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.417b20051661413c7acb87d14ba1b51b.svg";
export { ForwardRef as ReactComponent };